import * as angular from "angular";
import { ScreenUtils } from "../../helper/screen.helper";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { DialogUtils } from "../../helper/dialog.helper";

let GettingStartedComponent = {
    selector: "vcGettingStarted",
    templateUrl: "/angular/components/campaign/getting-started.component.html",
    bindings: {},
    controller: class GettingStartedComponentController {
        public page: number = 1;
        public isSaving: boolean = false;
        public menuOpen: boolean = false;
        public hasSampleData: boolean = false;

        private $window: any;
        private dialog: DialogUtils;

        public readonly screen: ScreenUtils;
        private campaignDataProvider: CampaignDataProvider;
        private navigationBarHelperService: NavigationBarHelperService;

        public menuItems: any = [
            {
                section: "FIRST STEPS",
                items: [
                    { text: "Inviting your team", icon: "group_add", page: 2 },
                    { text: "Import your data", icon: "cloud_upload", page: 3 },
                    {
                        text: "Getting to know the app",
                        icon: "explore",
                        page: 4,
                    },
                ],
            },
            {
                section: "KEY FEATURES",
                items: [
                    { text: "Map & Turf Cutting", icon: "map", page: 5 },
                    { text: "Interaction Statuses", icon: "flag", page: 6 },
                    { text: "Field Tracking", icon: "gps_fixed", page: 7 },
                    {
                        text: "Custom Canvassing App",
                        icon: "phone_iphone",
                        page: 8,
                    },
                ],
            },
        ];

        constructor(
            $window: any,
            $cookies: any,
            $routeParams: any,
            CampaignDataProvider: CampaignDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            DialogUtils: DialogUtils,
            ScreenUtils: ScreenUtils
        ) {
            this.$window = $window;
            this.dialog = DialogUtils;

            this.screen = ScreenUtils;
            this.campaignDataProvider = CampaignDataProvider;
            this.navigationBarHelperService = NavigationBarHelperService;
            this.navigationBarHelperService.navigationBarHidden = true;
            this.page = $routeParams.page ?? 1;
            $cookies.put("started", 1);
            this.campaignDataProvider.hasSampleData().then((hasSampleData) => {
                this.hasSampleData = hasSampleData;
                if (!hasSampleData) {
                    this.campaignDataProvider.allowedToEnableSampleData();
                }
            });
        }

        $onInit() {
            this.menuOpen = !this.screen.medScreen();
        }

        setPage(page: number) {
            this.page = page;
        }

        toggleSampleData($event: any) {
            let bodyText = this.hasSampleData
                ? "<p>Are you sure you want to remove this sample data?  " +
                  "This will remove your sample contacts, houses, interactions etc.</p>" +
                  "<p> Don't worry, if you change your mind you can restore this" +
                  " sample data</p>"
                : "<p> Restore the sample contact and houses to help you demonstrate or test key workflows.</p>  " +
                  "<p> Your existing customizations won’t be affected.</p>";
            this.dialog
                .delete({
                    targetEvent: $event,
                    locals: {
                        bodyText,
                        title: this.hasSampleData
                            ? "Clear sample data?"
                            : "Restore sample data",
                    },
                })
                .then(() => {
                    if (this.hasSampleData) {
                        this.campaignDataProvider
                            .deleteSampleData()
                            .then(() => {
                                this.$window.location.reload();
                            });
                    } else {
                        this.campaignDataProvider
                            .restoreSampleData()
                            .then(() => {
                                this.$window.location.reload();
                            });
                    }
                });
        }
    },
};

angular
    .module("campaign")
    .component(GettingStartedComponent.selector, GettingStartedComponent);
